export default {
  name: 'ContactCard',
  props: {
    contact: Object,
    title: String,
    large: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getTitle () {
      if (this.title) {
        return this.title;
      }
      return '';
    }
  }
}
